import { AxiosInstance } from "axios";
import { Role, } from './Roles.type'

export default class RolesService {
    private axios: AxiosInstance;
    constructor(axios: AxiosInstance) {
        this.axios = axios;
    };

    public async getAllRolesInDBAdminPCModule(): Promise<Role[]> {
        const url: string = `/roles/company_admin/pc_module`
        return this.axios.get(url)
    };

}